(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name crewing.factory:CrewingRequest
     *
     * @description
     *
     */
    angular
        .module('crewing')
        .factory('CrewingRequest', CrewingRequest);

    function CrewingRequest() {

        var getSearchBlockDetailsRequest = function (_blockId, _crewScheduleBlockId, _isPattern) {
            return {
                blockId: _blockId,
                crewScheduleBlockId: _crewScheduleBlockId,
                partOfPattern: _isPattern || false
            };
        };

        var getSendAlertRequest = function (params) {
            return {
                crewProfileId: params.crew.crewProfileId,
                affectedDutyDate: params.alertDate,
                affectedDuty: null,
                content: params.message
            };
        };

        var getSendSmsRequest = function (params) {
            var req = {
                crewProfileIdList: params.crewProfileId,
                content: params.message,
                hasConfirmation: params.isConfirm,
                confirmationDuration: params.no_of_house
            };
            return req;
        };

        //getAssignDirectEventParam
        var getAssignDirectEventRequest = function (_crewProfileId, _eventCode, _startDate, _endDate, _requested, _isShowCrewPortal,isCustomDateRange,customDateRange, forceAssignLeave,isUserConfirm,selectedBase) {

        	if(isCustomDateRange == undefined || isCustomDateRange == null){
        		isCustomDateRange = false;
        	}

        	if(customDateRange == undefined || customDateRange  == null){
        		customDateRange = [];
        	}
          if(forceAssignLeave == undefined || forceAssignLeave == null) { forceAssignLeave = false;}

            return {
                crewProfileId: _crewProfileId,
                eventCode: _eventCode,
                startDate: _startDate,
                endDate: _endDate,
                requested: _requested,
                userConfirmNotShowInCrewPortal : _isShowCrewPortal,
                customSelectedDates : isCustomDateRange,
                customSelectedDateList : customDateRange,
              forceAssignLeave : forceAssignLeave,
              userConfirm: !!isUserConfirm,
              startLocation:selectedBase,
              endLocation:selectedBase,
            };
        };


        var getCrewScheduleEmailRequest = function (_crewProfileId, _startDate, _endDate) {
            return {
                schStartDate: _startDate,
                schEndDate: _endDate,
                crewProfId: _crewProfileId
            };
        };

        var getSchedulePublishRequest = function (_crewTypeCode, _fromDate, _toDate) {
            return {
                crewType: _crewTypeCode,
                fromDate: _fromDate,
                toDate: _toDate
            };
        };

        var getIsPublishedRequest = function (_crewTypeCode, _fromDate, _toDate) {
            return {
                crewType: _crewTypeCode,
                fromDate: _fromDate,
                toDate: _toDate
            };
        };

        var getIsCrewPublishedRequest = function (_crewProfileId, _fromDate, _toDate) {
          return {
            crewProfileIds: _crewProfileId,
            fromDate: _fromDate,
            toDate: _toDate
          };
        };

        var getCheckPairingOpenRequest = function (_patternId, _crewTypeCode) {
            return {
                patternId: _patternId,
                crewTypeCode: _crewTypeCode
            };
        };

        var getSaveMemoRequest = function (param) {
            return {
                memoId: param.memoId,
                version: param.version,
                crewProfileId: param.crewProfileId,
                memoCategoryCode: param.memoCategory && param.memoCategory.categoryCode,
                memoDate: param.memoDate,
                message: param.message,
                showOnCrewScheduleFlag: param.showOnCrewScheduleFlag ? 'Y' : 'N'
            };
        };

        var getCopyPasteRequest = function (param) {
            var getCrewDTOs = function(param) {
              var tmp = [];
              angular.forEach(param, function(crewDTO) {
                tmp.push({
                  crewProfileId: crewDTO.crewProfileId,
                  flyingDuration: crewDTO.flyingDuration,
                  targetDuration: crewDTO.targetDuration
                });
              });
              return tmp;
            };
            return {
                crewScheduleBlockId: param.crewScheduleBlockId,
                crewProfileId: param.crewProfileId,
                crewType: param.crewType,
                userConfirm: param.userConfirm,
                ignoreExpiry: param.ignoreExpiry,
                notShowingInCrewPortal: param.isShowInPortal,
                crewDTOs: getCrewDTOs(param.crewDTOs)
            }
        };

        var getCutPasteDutyRequest = function (param) {
            var getCrewDTOs = function(param) {
              var tmp = [];
              angular.forEach(param, function(crewDTO) {
                tmp.push({
                  crewProfileId: crewDTO.crewProfileId,
                  flyingDuration: crewDTO.flyingDuration,
                  targetDuration: crewDTO.targetDuration
                });
              });
              return tmp;
            };
            return {
                cutCrewProfileId: param.cutCrewProfileId,
                crewScheduleBlockId: param.crewScheduleBlockId,
                pasteCrewProfileId: param.pasteCrewProfileId,
                pasteCrewType: param.pasteCrewType,
                userConfirm: !!param.userConfirm,
                ignoreExpiry: !!param.ignoreExpiry,
                notShowingInCrewPortal: param.isShowInPortal,
                crewDTOs: getCrewDTOs(param.crewDTOs)
            };
        };

        var getHistoryRequest = function (crewProfileId, selectedDate) {
            return {
                crewProfileId: crewProfileId,
                startDate: selectedDate,
                endDate: selectedDate
            };
        };

        var getRegulationRequest = function (crewProfileId, crewScheduleBlockId) {
            return {
                crewProfileId: crewProfileId,
                crewScheduleBlockId: crewScheduleBlockId,
                gcaaFlag: 'Y'
            };
        };

        var getAssignTrainingRequest = function (trainingData, flags, isShowInPortal, isHideinCrewPortal) {
            var req = {
                crewProfileId: trainingData.crewProfileId,
                trainingProgramId: trainingData.trainingProgramId,
                trainingSlotProgramId: trainingData.trainingProgram && trainingData.trainingProgram.trainingSlotPrgramId,
                trainingProgDetailId: trainingData.trainingProgramDetail && trainingData.trainingProgramDetail.trainingProgramDetailId,
                trainingSlotId: trainingData.trainingSlotId,
                courseId: null,
                courseTxnId: null,
                assignDate: trainingData.startDateZulu,
                assignTime: trainingData.startTimeZulu,
                continueIllegal: !!flags.isContinueIllegal,
                userConfirm: !!flags.isUserConfirm,
                expiryUpdatable: !!flags.isExpiryUpdatable,
                ignoreConflicts: !!flags.isIgnoreConflicts,
                ignoreExpiries: !!flags.isIgnoreExpiries,
                ignoreParentHubDeletedConflict: !!flags.isIgnoreParentHubDeletedConflict,
                userConfirmNotShowInCrewPortal: isShowInPortal,
                hideinCrewPortal: isHideinCrewPortal
            };
            return req;
        };

        var getTrainingRequest = function (data, crewProfileId) {
            return {
                fromDate: data,
                toDate: data,
                crewProfileId: crewProfileId,
                pageSize: 100,
                startPosition: 1
            };
        };

        var assignSbyPatternRequest = function (crewProfileId, pattern, crewScheduleBlockId,isUserConfirm,isTargetHoursValid,sbyCallOutDateTime) {
          return {
            crewProfileId: crewProfileId,
            patternId: pattern.patternId,
            sbyCrewSchdBlockId: crewScheduleBlockId,
            userConfirm : !!isUserConfirm,
            targetHoursValid : isTargetHoursValid,
            sbyCallOutDateTime : sbyCallOutDateTime
          };
        };

        var getAssignPatternRequest = function (crewProfileId, pattern, isRequest, isCallFromDayOff, isObsFlight, isHideinCrewPortal, isContinueIllegal, isUserConfirm, isShowInPortal, isComplementFilled,isTargetHoursValid,isAirportRecencyOverridden,dutyChangeReason,message,overriddenViolations) {
            var complementFilled = false;
            if (isComplementFilled === true){
              complementFilled = true;
            }
            console.log("getAssignPatternRequest ", complementFilled);
            var violationListString = '';

            if (overriddenViolations !== null && overriddenViolations.length > 0) {
            for (var i = 0; i < overriddenViolations.length; i++) {
              violationListString += overriddenViolations[i];
              if (i < overriddenViolations.length - 1) {
                violationListString += ', ';
              }
            }
            }

            return {
                crewProfileId: crewProfileId,
                patternId: pattern.patternId,
                request: !!isRequest,
                calledFromDayOff: !!isCallFromDayOff,
                obsFlight: !!isObsFlight,
                hideinCrewPortal: !!isHideinCrewPortal,
                continueIllegal: !!isContinueIllegal,
                userConfirm: !!isUserConfirm,
                userConfirmNotShowingInCrewPortal: isShowInPortal,
                crewComplementChangesDone: complementFilled,
                targetHoursValid: isTargetHoursValid,
                overriddenAirportRecency: isAirportRecencyOverridden,
                dutyChangeReason: !!dutyChangeReason? dutyChangeReason:null,
                dutyChangeComment: !!message? message : null,
                overriddenViolations: violationListString
            };
        };

      var getReplacingOverlappingRequest = function (listDuties, newPattern, crewProfileId, existingCrewScheduleChange) {
        return {
          deleteList: listDuties,
          newPatternId: newPattern,
          crewProfileId: crewProfileId,
          existingCrewScheduleChangeId: existingCrewScheduleChange
        };
      };

        var getReplacePatternRequest = function (crewProfileId, pattern, isRequest, isCallFromDayOff, isContinueIllegal, isUserConfirm, isShowInPortal,
                                                 previousCrewScheduleBlockId,checkInDate,checkInTime,patternName,isTargetHoursValid,crewDTOs, isAirportRecencyOverridden) {
          var getCrewDTOs = function(param) {
            var tmp = [];
            angular.forEach(param, function(crewDTO) {
              tmp.push({
                crewProfileId: crewDTO.crewProfileId,
                flyingDuration: crewDTO.flyingDuration,
                targetDuration: crewDTO.targetDuration
              });
            });
            return tmp;
          };
          return {
            crewProfileId: crewProfileId,
            patternId: pattern.patternId,
            request: !!isRequest,
            calledFromDayOff: !!isCallFromDayOff,
            continueIllegal: !!isContinueIllegal,
            userConfirm: !!isUserConfirm,
            userConfirmNotShowingInCrewPortal: isShowInPortal,
            previousCrewScheduleBlockId: previousCrewScheduleBlockId,
            checkInDate: checkInDate,
            checkInTime: checkInTime,
            oldPatternName:patternName,
            targetHoursValid : isTargetHoursValid,
            crewDTOs : getCrewDTOs(crewDTOs),
            overriddenAirportRecency: isAirportRecencyOverridden
          };
        };

        var getSwapRequest = function (firstDuty, secondDuty, crewDTOs, isUserConfirm, isIgnoreExpiry, isShowInPortal) {
            var getCrewDTOs = function(param) {
                var tmp = [];
                angular.forEach(param, function(crewDTO) {
                    tmp.push({
                        crewProfileId: crewDTO.crewProfileId,
                        flyingDuration: crewDTO.flyingDuration,
                        targetDuration: crewDTO.targetDuration
                    });
                });
                return tmp;
            };

            var getUnAssignList = function (dutyOne, dutyTwo) {
                var tmp = [];
                angular.forEach([dutyOne, dutyTwo], function (duty) {
                    tmp.push({
                        crewProfileId: duty.crewInfo.crewProfileId,
                        crewScheduleBlockId: duty.crewScheduleBlockId,
                        crewType: duty.crewInfo.crewTypeCode
                    });
                });
                return tmp;
            };

            var getAssignList = function (dutyOne, dutyTwo) {
                var tmp = [];
                tmp.push({
                    crewProfileId: dutyOne.crewInfo.crewProfileId,
                    crewScheduleBlockId: dutyTwo.crewScheduleBlockId,
                    crewType: dutyOne.crewInfo.crewTypeCode
                });
                tmp.push({
                    crewProfileId: dutyTwo.crewInfo.crewProfileId,
                    crewScheduleBlockId: dutyOne.crewScheduleBlockId,
                    crewType: dutyTwo.crewInfo.crewTypeCode
                });
                return tmp;
            };

            return {
                assignList: getAssignList(firstDuty, secondDuty),//SwapDTO
                unAssignList: getUnAssignList(firstDuty, secondDuty),//SwapDTO
                userConfirm: !!isUserConfirm,
                ignoreExpiry: !!isIgnoreExpiry,
                bothBlocksNotShowing:isShowInPortal,
                crewDTOs: getCrewDTOs(crewDTOs)
            };
        };


        var getPatternSearchRequest = function (crewProfileId, date, event, crewScheduleBlockId) {

            var request = {
              crewProfileId: crewProfileId,
              patternStartDate: date,
              patternEndDate: date,
              patternStartTime: null,
              patternEndTime: null,
              crewScheduleBlockId: crewScheduleBlockId
            };

            if (event !== null && event !== undefined){

              var callOutNotifyDate = null;
              var callOutNotifyTime = null;

              if(event.callOutNotifyDateTime != null && event !== undefined){
                var parts = event.callOutNotifyDateTime.split(' ');
                callOutNotifyDate = parts[0];
                callOutNotifyTime = parts[1];
              }

              request = {
                crewProfileId: crewProfileId,
                patternStartDate: callOutNotifyDate!== null? callOutNotifyDate: event.checkInDate,
                patternEndDate: event.checkOutDate,
                patternStartTime: callOutNotifyTime != null ? callOutNotifyTime: event.checkInTime,
                patternEndTime: event.checkOutTime
              }
            }

            console.log("request =================++++++:", request);
            return request;
        };


		var getUnAssignBlockRequest = function(param,crewDTOs, isComplementFilled) {
			var getBlockCol = function(param) {
				var tmp = [];
				angular.forEach(param, function(block) {
					tmp.push({
						crewProfileId: block.crewInfo.crewProfileId,
						crewSchdBlockId: block.blockId
					});
				});
				return tmp;
			};

			var getCrewDTOs = function(param) {
        var tmp = [];
        angular.forEach(param, function(crewDTO) {
      	  tmp.push({
      	    crewProfileId: crewDTO.crewProfileId,
      	    flyingDuration: crewDTO.flyingDuration,
      	    targetDuration: crewDTO.targetDuration
      	  });
      	});
      	return tmp;
      };



			var request = {
				unAssignColl: getBlockCol(param),
				crewDTOs : getCrewDTOs(crewDTOs),
				crewComplementChangesDone: isComplementFilled
			};
			return request;
		};


		var getAcknowledgeDutyRequest = function (searchParam) {
		  console.log("getAcknowledgeDutyRequest :", searchParam);
      var request = {
        crewProfileId: searchParam.crewDTO.crewProfileId,
        crewScheduleBlockId: searchParam.blocks[0].crewScheduleBlockId,
      };
      return request;
    };

    var getSearchBlockDetailsTrainingRequest = function (param, isPattern) {
        //console.log(JSON.stringify(param));
          var requestList = [];
          angular.forEach(param, function (block) {
            requestList.push({
              blockId: block.blockId,
              crewScheduleBlockId: block.crewScheduleBlockId,
              partOfPattern: isPattern || false
            });
          });

        return requestList;
      };

        var getOpenPairingRequest = function (searchParam) {
            var req = {
                startDate: searchParam.fromDate,
                endDate: searchParam.toDate,
                fleetExperience: (searchParam.aircraftType && searchParam.aircraftType.airCraftType ) || null,
                trainingPatterns: searchParam.isTrainingPattern,
                crewType: searchParam.crewType && searchParam.crewType.crewTypeCode,
                crewTypeMasterCode:(searchParam.crewTypeMaster && searchParam.crewTypeMaster.code)|| null,
                languageCode:(searchParam.selectedLanaguage && searchParam.selectedLanaguage.languageCode) || null,
                pairingBase:(searchParam.crewBase && searchParam.crewBase.airPortCode) || null,
                gender:(searchParam.gender && searchParam.gender.code)||null
            };
            return req;
        };

        var getCrewScheduleRequest = function (searchParam) {
            var req = {
                pageSize: searchParam.pageSize || 30,
                startPosition: 1,
                fromDate: searchParam.fromDate,
                toDate: searchParam.toDate,
                crewType: searchParam.crewType && searchParam.crewType.crewTypeCode,
                category: searchParam.crewCategory && searchParam.crewCategory.categoryCode,
                mgtPositions:searchParam.crewPosition,
                base: searchParam.crewBase && searchParam.crewBase.airPortCode,
                acModel: searchParam.aircraftType && searchParam.aircraftType.airCraftType,
                trainingPattern: searchParam.isTrainingPattern,
                showAllCrew: searchParam.isShowAllCrew,
                group: searchParam.crewGroup && searchParam.crewGroup.groupCode,
                crewIds: searchParam.crewIds,
                displayTimeZone: searchParam.displayTimeZone,
                crewTypeMaster: (searchParam.crewTypeMaster && searchParam.crewTypeMaster.code) || null,
                languageCode: (searchParam.selectedLanaguage && searchParam.selectedLanaguage.languageCode) || null,
                nationality: (searchParam.nationality && searchParam.nationality.code) || null,
                gender: (searchParam.gender && searchParam.gender.code) || null,
                crewBatchCode:(angular.isUndefined(searchParam.batchCode) || searchParam.batchCode == null) ?null : searchParam.batchCode.crewBatchCode,
                notShowingCrewPortal: (angular.isUndefined(searchParam.notShowingCrewPortal) || searchParam.notShowingCrewPortal==null) ? null : searchParam.notShowingCrewPortal.code,
                showIllegalOnly: searchParam.showIllegalOnly,
                crewOperType:(angular.isUndefined(searchParam.crewOperType) || searchParam.crewOperType == null) ?null : searchParam.crewOperType.operTypeCode,
                /*sortKey:searchParam.sortKey.code,
                sortDirection:searchParam.sortDirection.code*/
                sortKey:angular.isUndefined(searchParam.sortKey)?'crewId':searchParam.sortKey.code,
                sortDirection:angular.isUndefined(searchParam.sortDirection)?'ASC':searchParam.sortDirection.code,
                showLayoverOnly: searchParam.showLayoverOnly,

            };
            return req;
        };

        var getAssignEventRequest = function (formData, isContinueIllegal, isUserConfirm,dutyChangeReason,message, violatedRegulations) {
            var violationListString = '';

                        if (violatedRegulations !== null && violatedRegulations.length > 0) {
                        for (var i = 0; i < violatedRegulations.length; i++) {
                          violationListString += violatedRegulations[i];
                          if (i < violatedRegulations.length - 1) {
                            violationListString += ', ';
                          }
                        }
                        }
            return {
                crewProfileId: formData.crewProfileId,
                eventId: formData.event.event_id,
                request: formData.isRequest.value,
                calledFromDayOff: formData.isCallFromDayOff.value,
                obsFlight: formData.isObsFlight.value,
                hideinCrewPortal: formData.isHideinCrewPortal.value,
                offC: formData.isOffC.value,
                continueIllegal: !!isContinueIllegal,
                userConfirm: !!isUserConfirm,
                startDate: formData.startDate.value,
                startTime: formData.startTime.value,
                selectedDates:formData.selectedDates,
                endDate: formData.endDate.value,
                endTime: formData.endTime.value,
                startLocation: formData.startLocation.value && formData.startLocation.value.airPortCode,
                endLocation: formData.endLocation.value && formData.endLocation.value.airPortCode,
                eventOccuringFlight: formData.eventOccurringFlight.value && formData.eventOccurringFlight.value.eventId,
                dutyPeriod: moment.duration(formData.dutyPeriod.value).asMinutes(),
                excludeFromPayment: formData.isExcludeFromPayment.value,
                airportSBY: formData.isAirportStandby.value,
                aircraftType: formData.aircraftType.value && formData.aircraftType.value.airCraftType,
                remarks: formData.remark.value,
                userConfirmNotShowingInCrewPortal: formData.isShowPortal,
                mOff: angular.isUndefined(formData.isMoff)?null:formData.isMoff.value,
                dutyChangeReason: !!dutyChangeReason? dutyChangeReason:null,
                dutyChangeComment: !!message? message : null,
                violatedRegulations: violationListString
            };
        };

        var getEditEventRequest = function (formData, isContinueIllegal, isUserConfirm) {
            return {
                crewScheduleBlockId: formData.crewScheduleBlockId,
                patternId: formData.patternId,
                crewProfileId: formData.crewProfileId,
                eventId: formData.event.event_id,
                eventDescription: formData.event.eventDescription,
                eventCode: formData.event.eventCode,
                eventCategoryCode: formData.event.eventCategoryCode,
                startDate: formData.startDate.value,
                startTime: formData.startTime.value,
                endDate: formData.endDate.value,
                endTime: formData.endTime.value,
                startLocation: formData.startLocation.value && formData.startLocation.value.airPortCode,
                endLocation: formData.endLocation.value && formData.endLocation.value.airPortCode,
                dutyPeriod: moment.duration(formData.dutyPeriod.value).asMinutes(),
                excludeFromPayment: formData.isExcludeFromPayment.value,
                calledFromDayOff: formData.isCallFromDayOff.value,
                hideinCrewPortal: formData.isHideinCrewPortal.value,
                offC: formData.isOffC.value,
                continueIllegal: !!isContinueIllegal,
                userConfirm: !!isUserConfirm,
                remarks: formData.remark.value,
                mOff: formData.isMoff.value
            };
        };

        var getCheckInCheckOutRequest = function (param) {
            return {
                blockId: param.blockId,
                crewScheduleBlockId: param.crewScheduleBlockId,
                checkInDate: param.checkInDateStr,
                checkOutDate: param.checkoutDateStr,
                checkInTime: param.checkInTimeStr,
                checkOutTime: param.checkoutTimeStr,
                crewSchdBlockVersion: param.crewSchdBlockVersion,
                callFromDayOff: param.callFromDayOff,
                obsFlight: param.obsFlight,
                request: param.request,
                continueIllegal: param.continueIllegal,
                crewProfileId: param.crewProfileId,
                skipTrainingFromStageUpgrade: !!param.skipTrainingFromStageUpgrade
            };
        };

        var getEditBlockTrainingProgramRQ = function (selectedCrew, continueOveride, pic, crewSchdBlockId, type, flightLegId, flightLegIdList,trainingProgramId, trainingProgramDetailId, version, fam) {
            return {
                selectedCrew: selectedCrew,
                continueOveride: continueOveride,
                pic: pic,
                fam: fam,
                crewSchdBlockId: crewSchdBlockId,
                trainingType: type,
                trainingProgramId: trainingProgramId,
                trainingProgramDetailId: trainingProgramDetailId,
                flightOrTrainigSlotId: flightLegId,
                flightOrTraningSlotIdList: flightLegIdList,
                version: version,
                ignoreTrainerExist: true,
                ignoreExpiryExist: true
            }
        };

        var getUpdateTrainerTraineeRequest = function (param) {

        	var courseInfo = populateCourseInfo(param);
        	
        	// Build selectedCrewList with crew profile id, crew id, and hub
        	var selectedCrewList = [];
        	if(param.crewProfileIds && param.crewIds && param.crewHubs) {
        		for(var i = 0; i < param.crewProfileIds.length; i++) {
        			selectedCrewList.push({
        				crewProfileId: param.crewProfileIds[i],
        				crewId: param.crewIds[i],
        				crewHub: param.crewHubs[i]
        			});
        		}
        	}

            return {
                ignoreExpiries: false,
                type: param.type,
                trainingProgrameDetailId: param.trainingProgramDetailId,
                trainingProgramId: param.trainingProgramId,
                crewShldBlkId: param.crewScheduleBlockId,
                crewProfileId: param.crewProfileId,
                crewId: param.crewId,
                crewHub: param.crewHub,
                assignedAsType: param.assignedAsType,
                crewShldTraininhSlotId: param.crewScheduleTrainingSlotId,
                selectedCrewSchedTrainingSlotIds : param.selectedCrewSchedTrainingSlotIds,
                crewShldVersion: param.version,
                trainingSlotId: param.isTraining ? param.trainingSlotId : param.selectedFlightLegId,
                courseId: courseInfo.courseId,
                courseTxnId : courseInfo.courseTxnId,
                courseStartDate: param.courseStartDate,
              courseStartTime: param.courseStartTime,
              crewProfileIds: param.crewProfileIds,
              crewIds: param.crewIds,
              crewHubs: param.crewHubs,
              selectedCrewList: selectedCrewList,
              selectedFlightLegIds: param.selectedFlightLegIds,
              crewProfileIdToTypeMap:param.crewProfileIdToTypeMap||null,

              previousType: null,
                modelNo: null
            };
        };

        var populateCourseInfo = function(param) {
        	var courseId = null;
        	var courseTxnId = null;

        	if(param.assignedAsCourse){
        		var array = param.assignedAsCourse.split("|");
        		courseId = array[0] ? array[0] : null;
        		courseTxnId = ( array[1] && array[1] != -1 ) ? array[1] : null;
        	}

        	return { courseId : courseId ,  courseTxnId : courseTxnId };
        };

        var getLanguageWarningRequest = function (crewProfileId, isDelete, blockId) {
            return {
                patternId: !!isDelete ? null : blockId,
                crewProfileId: crewProfileId,
                delete: !!isDelete,
                crewSchdBlockId: !!isDelete ? blockId : null
            };
        };

        var getDistributionWarning = function (crewProfileId, blockId) {
            return {
                patternId: blockId,
                crewProfileId: crewProfileId
            };
        };

        var getUpdateFlightExpiryRequest = function (selectedFlight, crewList, result, remarks, validationNo, ignoreFlags) {
          // ignoreFlags: { ignoreExpiry: bool, ignoreExpiryProcess: bool, ignoreObjectExpiryExists: bool }
          ignoreFlags = ignoreFlags || {};

          crewList = crewList.filter(function(element) {
              return element !== undefined;
          });

          angular.forEach(crewList, function (crew) {

            var filteredCrew = selectedFlight.assignedCrewTrainingDetails.filter(function (item) {
              return item.crewProfileId === crew.crewProfileId;
            });
            crew.crewSchdFlightLegId = filteredCrew[0].crewSchdFlightLegId;
            crew.crewSchdFlightLegVersion = filteredCrew[0].crewSchdFlightLegVersion;

          });


          var updateExpiryCrewDTOs = [];

          angular.forEach(crewList ,function(crew){

            if(!angular.isUndefined(crew)) {
                  // Find the crew in assignedCrewTrainingDetails to get otherHub and validation info
                  var crewTrainingDetail = selectedFlight.assignedCrewTrainingDetails.filter(function (item) {
                    return item.crewProfileId === crew.crewProfileId;
                  })[0];
                  
                  var updateExpiryCrewDTO = {
                    crewProfileId: crew.crewProfileId,
                    crewSchFlightLegId: crew.crewSchdFlightLegId,
                    crewSchFlightLegVersion: crew.crewSchdFlightLegVersion,
                    valTransactionId: crewTrainingDetail ? crewTrainingDetail.validationId : null,
                    valTransactionVersion: crewTrainingDetail ? crewTrainingDetail.version : null,
                    crewType: crew.crewTy,
                    crewId: crew.crewId,
                    otherHub: crewTrainingDetail ? crewTrainingDetail.otherHub : null
                  }

                  updateExpiryCrewDTOs.push(updateExpiryCrewDTO);
            }
          });

            return {
                departureDate: selectedFlight.estDepartureDateStr,
                departureTime: selectedFlight.estDepartureTimeStr,
                expiryUpgradeable: selectedFlight.expiryUpdatable,
                validityNo: validationNo,
                result: result,
                remarks: remarks,
                flightLegId: selectedFlight.flightLegId,
                crewType: null,
                modelNo: null,
                updateFlightExpiryCrews: updateExpiryCrewDTOs,
                ignoreExpiry: ignoreFlags.ignoreExpiry || false,
                ignoreExpiryProcess: ignoreFlags.ignoreExpiryProcess !== false,
                ignoreObjectExpiryExists: ignoreFlags.ignoreObjectExpiryExists || false,
                ignoreObjectExpiryProcess: ignoreFlags.ignoreObjectExpiryProcess || false
            };
        };

        var getUpdateBlockExpiryRequest = function (selectedTraining, crewList, result, remarks, validationNo) {

          var updateExpiryCrewDTOs = [];
          angular.forEach(crewList ,function(crew){

            var selectedCrewResult = _.find(selectedTraining.assignedCrewTrainingDetails, {crewProfileId: crew.crewProfileId});

            var updateExpiryCrewDTO = {
              crewProfileId: crew.crewProfileId,
              crewSchTrainingSlotId: selectedCrewResult.crewScheduleTrainingSlotId,
              crewSchTrainingSlotVersion: selectedCrewResult.crewSchdTrainingSlotVersion,
              valTransactionId: selectedCrewResult.validationId,
              valTransactionVersion: selectedCrewResult.version,
              crewId: crew.crewId
            };
            updateExpiryCrewDTOs.push(updateExpiryCrewDTO);
          });

            return {
                trainingStartDate: selectedTraining.trainingFromDateStr,
                trainingStartTime: selectedTraining.trainingFromTimeStr,
                expiryUpgradeable: selectedTraining.expiryUpdatable,
                validityNo: validationNo,
                result: result,
                module: null,
                remarks: remarks,
                trainingSlotId: selectedTraining.trainingSlotId,
                programId: selectedTraining.trainingProgramId,
                updateExpiryCrews: updateExpiryCrewDTOs,
                ignoreExpiry: true,
                ignoreExpiryProcess: true,
                ignoreObjectExpiryExists: true,
                ignoreObjectExpiryProcess: true
            };
        };

        var getFilterCrewScheduleRequest = function (filterParams) {
            var tmpDestinations = _.pluck(filterParams.airports, 'airPortCode'),
                tmpEvents = [],
                tmpLeave = [],
                isAllLeaves = false,
                isAllEvnts = false;

            if (!!_.find(filterParams.leaves, {id: 'D001'})) {
                isAllLeaves = true;
            } else {
                tmpLeave = _.pluck(filterParams.leaves, 'eventCode');
            }

            if (!!_.find(filterParams.events, {id: 'D001'})) {
                isAllEvnts = true;
            } else {
                tmpEvents = _.pluck(filterParams.events, 'eventCode');
            }

            return {
                flightNumbers: filterParams.flights,
                destinations: tmpDestinations || [],
                events: tmpEvents || [],
                leaves: tmpLeave || [],
                allLeaves: isAllLeaves,
                allEvents: isAllEvnts,
                date: filterParams.day,
                crewTypeMaster: filterParams.searchParams.crewTypeMaster || '',
                crewTypeCode: filterParams.searchParams.crewType || '',
                crewIds : filterParams.crewIds || ''
            };
        };

        var getShowInCrewPortalAll = function (crewMembers, searchParams) {
            return {
                fromDate : searchParams.fromDate,
                toDate : searchParams.toDate,
                crewProfileIds : crewMembers
            }
        };

        var getJoiningCrewParam = function (crewScheduleForBlockId,isPattern) {
        	return {
        		crewScheduleBlockId: crewScheduleForBlockId,
        		partOfPattern: isPattern || false
        	}
        };

        var getMessageManagerSearchRequest = function (requestData) {
        	return {
        		fromDate : requestData.fromDate,
	        	toDate : requestData.toDate,
	        	crewBase : !!requestData.crewBase && !!requestData.crewBase.airPortCode ? requestData.crewBase.airPortCode : null,
	        	crewProfileId : requestData.crewProfileId,
	        	refreshStatus : requestData.refreshStatus,
	        	pageSize : requestData.pageSize,
	        	startPosition : requestData.startPosition,
	        	status : !!requestData.status ? requestData.status.messageStatusCode : null
        	};
        };

        var getCreditHoursParam = function (param) {
          return {
            fromDate : param.fromDate,
            toDate: param.toDate,
            crewId: param.crewId,
            crewType:param.crewType
          }
        };

      var getFlyingHoursSearchRequest = function (_crewId, _fromDate, _toDate) {
        return {
          crewId: _crewId,
          fromDateLcl: _fromDate,
          toDateLcl: _toDate
        };
      };

      var getCheckDutyPrevNextBase = function (_pairingBase, _crewId, _dutyDate, _patternId) {
        return {
          pairingBase: _pairingBase,
          crewId: _crewId,
          dutyDate: _dutyDate,
          patternId: _patternId
        };
      };

      var getAirportRecencyCheckRequest = function(crewProfileId, patternId, dutyDate) {
        return {
          crewProfileId: crewProfileId,
          patternId: patternId,
          dutyStartDate: dutyDate
        };
      }

        return {
            assignDirectEventRequest: getAssignDirectEventRequest,
            assignEventRequest: getAssignEventRequest,
            assignPatternRequest: getAssignPatternRequest,
            replacePatternRequest: getReplacePatternRequest,
            assignSbyPatternRequest: assignSbyPatternRequest,
            assignTrainingRequest: getAssignTrainingRequest,
            checkInCheckOutRequest: getCheckInCheckOutRequest,
            crewScheduleEmailRequest: getCrewScheduleEmailRequest,
            checkPairingOpenRequest: getCheckPairingOpenRequest,
            crewScheduleRequest: getCrewScheduleRequest,
            copyPasteRequest: getCopyPasteRequest,
            cutPasteDutyRequest: getCutPasteDutyRequest,
            editEventRequest: getEditEventRequest,
            editBlockTrainingProgramRQ: getEditBlockTrainingProgramRQ,
            filterCrewScheduleRequest: getFilterCrewScheduleRequest,
            historyRequest: getHistoryRequest,
            isPublishedRequest: getIsPublishedRequest,
            isCrewPublishedRequest: getIsCrewPublishedRequest,
            languageWarningRequest: getLanguageWarningRequest,
            openPairingRequest: getOpenPairingRequest,
            patternSearchRequest: getPatternSearchRequest,
            regulationRequest: getRegulationRequest,
            searchBlockDetailsRequest: getSearchBlockDetailsRequest,
            searchBlockDetailsTrainingRequest: getSearchBlockDetailsTrainingRequest,
            sendAlertRequest: getSendAlertRequest,
            sendSmsRequest: getSendSmsRequest,
            schedulePublishRequest: getSchedulePublishRequest,
            saveMemoRequest: getSaveMemoRequest,
            swapRequest: getSwapRequest,
            trainingRequest: getTrainingRequest,
            unAssignBlockRequest: getUnAssignBlockRequest,
            acknowledgeDutyRequest: getAcknowledgeDutyRequest,
            updateTrainerTraineeRequest: getUpdateTrainerTraineeRequest,
            updateFlightExpiryRequest: getUpdateFlightExpiryRequest,
          updateBlockExpiryRequest: getUpdateBlockExpiryRequest,
            getDistributionWarning: getDistributionWarning,
            getShowInCrewPortalAll: getShowInCrewPortalAll,
            getJoiningCrewParam: getJoiningCrewParam,
            getMessageManagerSearchRequest : getMessageManagerSearchRequest,
            getCreditHoursParam:getCreditHoursParam,
            getFlyingHoursSearchRequest:getFlyingHoursSearchRequest,
            replacingOverlappingRequest: getReplacingOverlappingRequest,
            checkDutyPrevNextBase: getCheckDutyPrevNextBase,
            checkAirportRecency: getAirportRecencyCheckRequest
        };
    }
}());
